<template>
    <div v-if="veiculo && veiculo.uuid">
        <button v-if="veiculo.roubado" @click="desabilitar" class="btn btn-block btn-danger btn-xs">DESABILITAR ALERTA DE TRANSMISSÃO</button>
        <button v-else @click="habilitar" class="btn btn-block btn-success btn-xs">HABILITAR ALERTA DE TRANSMISSÃO</button>
    </div>
</template>

<script>
import {Veiculo} from "../../class";

export default {
    name: "HabilitarAlertaTransmissao",
    props: {
        veiculo: {
            default: null
        }
    },
    methods: {
        habilitar () {
            swal({
                title: 'Posso Confirmar?',
                text: "Habilitar o alerta de transmissão?",
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, pode habilitar!'
            }).then(() => {
                try {
                    Veiculo.roubado(this.veiculo.uuid, true).then(() =>
                        this.$emit('reload', this.veiculo.id_veiculo)
                    );
                } catch (err) {
                    console.error(err);
                    return toastr.error("Não Habilitado");
                }
            });
        },
        desabilitar () {
            swal({
                title: 'Posso Confirmar?',
                text: "Desabilitar o alerta de transmissão?",
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, pode desabilitar!'
            }).then(() => {
                try {
                    Veiculo.roubado(this.veiculo.uuid, false).then(() =>
                        this.$emit('reload', this.veiculo.id_veiculo)
                    );
                } catch (err) {
                    console.error(err);
                    return toastr.error("Não Desabilitado");
                }
            });
        }
    }
}
</script>

<style scoped>

</style>
